
import { useState, useEffect } from 'react';
import { getShopById } from '@/lib/supabase/shops';

export const useShopTheme = (shopId: string | null) => {
  const [shopColor, setShopColor] = useState<string>('bg-amber-600 hover:bg-amber-700');
  const [ctaButtonText, setCtaButtonText] = useState<string>('Commander الآن اطلب');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  
  useEffect(() => {
    if (shopId) {
      setIsLoading(true);
      const loadShopData = async () => {
        try {
          const shopData = await getShopById(shopId);
          if (shopData) {
            // Si le shop a une couleur personnalisée, l'utiliser
            if (shopData.primary_color) {
              // Create a valid Tailwind class or use inline styling
              setShopColor(`bg-[${shopData.primary_color}] hover:bg-[${shopData.primary_color}]/80`);
            }
            
            // If shop has a custom CTA button text, use it
            if (shopData.cta_button_text) {
              setCtaButtonText(shopData.cta_button_text);
            }
          }
        } catch (error) {
          console.error("Erreur lors du chargement des données du shop:", error);
        } finally {
          setIsLoading(false);
        }
      };
      loadShopData();
    }
  }, [shopId]);

  return { shopColor, ctaButtonText, isLoading };
};
